import script from "./ViaggioDataDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ViaggioDataDialog.vue?vue&type=script&setup=true&lang=js"

import "./ViaggioDataDialog.vue?vue&type=style&index=0&id=55e245db&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e245db"]])

export default __exports__